itsoftApp.createModule("mouseParallax", function() {
    var module = this;

    var initMouseParallax = function () {
        var elements = document.querySelectorAll('.js-parallax-mouse');
        var el;
        var speed;
        var x;
        var y;

        var move = function(elements) {
            for (let index = 0; index < elements.length; index++) {
                el = elements[index];
                speed = el.getAttribute('data-parallax-speed');

                if (el.hasAttribute('data-parallax-rev')) {
                    el.style.transform = 'translate3d(' + x * speed + 'px, ' + y * speed + 'px, 0)';
                } else {
                    el.style.transform = 'translate3d(-' + x * speed + 'px, -' + y * speed + 'px, 0)';
                }
            }
        }

        if (elements) {
            window.addEventListener('mousemove', function (e) {
                x = e.clientX / window.innerWidth;
                y = e.clientY / window.innerHeight;

                move(elements);
            });
        }
    }

    initMouseParallax();

    module.callback = initMouseParallax;
});